<template>
    <div id="content">
        <div class="container">
            <div id="page-header-fixed">
                <div class="container">
                    <div id="page-header">
                        <ul class="breadcrumb">
                            <li class="icon">
                                <router-link :to="{path: '/'}">
                                    <img src="/themes/ito/images/back-home.svg" alt="">
                                </router-link>
                            </li>
                            <li class="active">{{$t('back_to_home')}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="mark-lesson" v-if="screen != 'start_test'"></div>
            <div class="card mt-20" :class="screen == 'test'?'box-leson':''" style="z-index: 11;overflow: inherit;">
                <div class="card-body" v-if="screen == 'start_test'">
                    <div class="card-title">{{$t('grade')}} {{test_id}} - {{$t('placement_test')}}</div>
                    <div class="card-content" style="height: calc(100vh - 285px); padding: 0;min-height: 550px;">
                        <div class="placement-container" style="max-width: 415px;margin: auto;height: 360px;padding: 110px 0px;">
                            <h3 class="popup-title mb-20">{{$t('placement_test')}}</h3>
                            <div class="d-flex quick-test-box text-center">
                                <img src="/themes/ito/images/reading.svg" style="width: 150px; margin: 0 auto;">
                            </div>
                            <div class="quick-test-bottom box-shadow-main d-flex mt-20" style="position: relative">
                                <div class="quick-test-bottom-text">
                                    <div class="txt-2-rows">
                                        <div class="text-right d-inline-block left-title">{{$t('total')}}:</div>
                                        <div class="d-inline-block right-text">{{placement_test.total_question}}
                                            {{$t('scores')}}
                                        </div>
                                    </div>
                                    <div class="txt-2-rows">
                                        <div class="text-right d-inline-block left-title">{{$t('time_allowance')}}:
                                        </div>
                                        <div class="d-inline-block right-text">{{placement_test.time}}
                                            {{$t('minutes')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="quick-test-condition">
                                    <h5 style="font-size: 15px;font-weight: 600;">{{$t('request')}}</h5>
                                    <h6 style="font-size: 14px">{{$t('must_correct_answer_more_than')}} {{placement_test.condition_pass}} {{condition_type}}</h6>
                                </div>
                            </div>
                            <div class="ito-btn-large btn-test mt-20" style="width: 100px; margin: 20px auto"
                                 @click="placementTest">
                                {{$t('start')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body" v-if="screen == 'test'">
                    <div class="card-content p-0" style="height: 100%">
                        <iframe :src="item.content"
                                frameborder="0" allowfullscreen width="100%" height="100%"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {getPlacementTest, startPlacementTest, resultPlacementTest} from "../../models/placement_test";


    export default {
        name: "PlacementTest",
        title: 'Placement test',
        props: [
            'user_info'
        ],
        data() {
            return {
                test_id: '',
                isLoading: false,
                item: {},
                screen: 'start_test',
                placement_test: '',
                condition_type: '%'
            };
        },

        created() {
            const {item_id} = this.$route.params;
            this.test_id = item_id;
            this.getPlacementItem()
        },
        mounted() {
            window.addEventListener('message', this.handleMessage)
        },
        beforeDestroy() {
            window.removeEventListener('message', this.handleMessage)
        },
        methods: {
            getPlacementItem() {
                const that = this;

                const {item_id} = that.$route.params;

                that.isLoading = true;

                getPlacementTest({
                    grade_id: item_id
                }).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        return;
                    }

                    this.placement_test = response.data.results[0] || {};
                    this.condition_type = this.placement_test.pass_type == 0? this.$i18n.t('corrects') : '%';

                    $('#updateGradeModal').modal("hide");
                    // $('#testPlacementModal').modal('show');
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);

                    console.error(response);
                });
            },
            placementTest() {
                const that = this;

                // that.getSoundClick();

                that.$store.commit("setLoading", true);

                startPlacementTest({
                    id: this.placement_test.id
                }).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }
                    that.item = response.data.results;
                    that.screen = 'test';
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);

                    console.error(response);
                });
            },
            handleMessage(event) {
                switch (event.data.action) {
                    case 'test_done':
                        axios.all([
                            resultPlacementTest({
                                id: this.placement_test.id,
                            }),
                        ]).then(axios.spread((response) => {
                            console.log(response);
                            if (response.data.code != 0) {
                                return;
                            }
                            if(response.data.results.pass_test == 1){
                                localStorage.setItem('grade', response.data.results.grade);
                            }
                        }));
                        break;
                    case 'test_close':
                        window.location.href = '/';
                        break;

                }
            },
        }
    }
</script>

<style scoped>
    #page-header .breadcrumb {
        margin-bottom: 0;
    }

    .quick-test-bottom-text {
        width: 100%;
    }

    .lesson-action-button span {
        display: block;
        width: 26px;
        height: 26px;
        margin: 13px auto;
        background: #ffffff;
        text-align: center;
        color: #f04821;
        font-size: 26px;
        line-height: 26px;
        font-weight: bold;
        border-radius: 100%;
        transform: rotate(45deg);
    }

    .mark-lesson {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        left: 0;
        right: 0;
        top: 0;
        z-index: 10;
    }

    .modal-sm {
        max-width: 400px;
    }

    .ito-icon-close {
        position: absolute;
        right: 18px;
    }

    .next-item-modal {
        background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
        border-radius: 20px;
        box-shadow: 4px 4px 0px 0px #00000012;
        border: none;
        padding: 5px 10px;
        color: #fff;
        margin-top: 10px;
    }

    .box-result-popup {
        padding: 7px 15px;
    }
    .quick-test-condition{
        width: 160px;
        background: #ffffff;
        height: 80px;
        position: absolute;
        right: 10px;
        top: 15px;
        border-radius: 8px;
        padding: 15px 5px;
        text-align: center;
    }
    .box-leson{
        position: fixed;
        width: 96%;
        height: 83vh;
        left: 2%;
        top: 10%;
    }
</style>